import {
  createAxiosClient,
  configureSdk,
  getRefreshToken,
  redirectToLogin
} from '@myapp/common-web-sdk';

const API_ROOT_URL = (process.env.REACT_APP_API_URL || window.location.origin).replace(/\/+$/, '');
const API_BASE_URL = `${API_ROOT_URL}/api/v1`;
const HEAD_ICON_API_URL = (process.env.REACT_APP_HEAD_ICON_API_URL || API_ROOT_URL).replace(/\/+$/, '');
const OPINION_API_URL = process.env.REACT_APP_OPINION_API_URL || 'http://localhost:8002';

const PUSH_BASE_URL = (process.env.REACT_APP_PUSH_URL || window.location.origin).replace(/\/+$/, '');
configureSdk({
  authBaseURL: API_BASE_URL,
  pushBaseURL: PUSH_BASE_URL,
  pushApiBaseURL: `${PUSH_BASE_URL}/push/v1`,
});

// 使用 SDK 创建主 API 客户端
const api = createAxiosClient({
  baseURL: API_BASE_URL,
  onAuthError: (error) => {
    console.error('Authentication failed:', error);
    redirectToLogin();
  }
});

// 认证 API
export const authAPI = {
  logout: () => {
    const refreshToken = getRefreshToken();
    return api.post('/auth/logout/', { refresh: refreshToken });
  },

  getProfile: () => api.get('/auth/profile/'),

  updateProfile: (data) => api.patch('/auth/profile/', data),

  changePassword: (oldPassword, newPassword, newPasswordConfirm) =>
    api.post('/auth/password/change/', {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    }),
};

// 用户管理 API
export const userAPI = {
  list: (params) => api.get('/users/', { params }),
  get: (id) => api.get(`/users/${id}/`),
  create: (data) => api.post('/users/', data),
  update: (id, data) => api.patch(`/users/${id}/`, data),
  delete: (id) => api.delete(`/users/${id}/`),
  lock: (id, reason) => api.post(`/users/${id}/lock/`, { reason }),
  unlock: (id) => api.post(`/users/${id}/unlock/`),
  resetPassword: (id, newPassword) =>
    api.post(`/users/${id}/reset-password/`, { new_password: newPassword }),
};

// 部门管理 API
export const departmentAPI = {
  list: (params) => api.get('/departments/', { params }),
  tree: () => api.get('/departments/tree/'),
  get: (id) => api.get(`/departments/${id}/`),
  create: (data) => api.post('/departments/', data),
  update: (id, data) => api.patch(`/departments/${id}/`, data),
  delete: (id) => api.delete(`/departments/${id}/`),
};

// 角色管理 API
export const roleAPI = {
  list: (params) => api.get('/roles/', { params }),
  get: (id) => api.get(`/roles/${id}/`),
  create: (data) => api.post('/roles/', data),
  update: (id, data) => api.patch(`/roles/${id}/`, data),
  delete: (id) => api.delete(`/roles/${id}/`),
};

// 权限管理 API
export const permissionAPI = {
  list: (params) => api.get('/permissions/', { params }),
  modules: () => api.get('/permissions/modules/'),
  get: (id) => api.get(`/permissions/${id}/`),
  create: (data) => api.post('/permissions/', data),
  update: (id, data) => api.patch(`/permissions/${id}/`, data),
  delete: (id) => api.delete(`/permissions/${id}/`),
};

// 登录日志 API
export const loginLogAPI = {
  list: (params) => api.get('/login-logs/', { params }),
  get: (id) => api.get(`/login-logs/${id}/`),
};

// 操作记录 API（仅超级管理员）
export const operationLogAPI = {
  list: (params) => api.get('/operation-logs/', { params }),
  get: (id) => api.get(`/operation-logs/${id}/`),
};

const headIconClient = createAxiosClient({
  baseURL: HEAD_ICON_API_URL,
  onAuthError: () => redirectToLogin(),
});

export const headIconAPI = {
  get: () => headIconClient.get('/api/head-icon/get', { responseType: 'blob' }),
};

// 意见 API - 使用 SDK 创建独立的客户端
const opinionAPIClient = createAxiosClient({
  baseURL: OPINION_API_URL,
  onAuthError: (error) => {
    console.error('Opinion API authentication failed:', error);
    redirectToLogin();
  }
});

// 意见 API 服务
export const opinionAPIService = {
  submit: (formData) => {
    return opinionAPIClient.post('/api/opinions', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  list: (params) => opinionAPIClient.get('/api/opinions', { params }),
  get: (id) => opinionAPIClient.get(`/api/opinions/${id}`),
  update: (id, data) => opinionAPIClient.patch(`/api/opinions/${id}`, data),
  getImage: (id, index) => opinionAPIClient.get(`/api/opinions/${id}/images/${index}`, {
    responseType: 'blob',
  }),
};

export default api;

const pushAPIClient = createAxiosClient({
  baseURL: `${PUSH_BASE_URL}/push/v1`,
  onAuthError: () => redirectToLogin(),
});

export const pushAPI = {
  currentUsers: (signal) => pushAPIClient.get('/current-users', { signal, timeout: 15000 }),
};
